



























































































































































import VueOptions from '@utils/VueOptions'

settings =
  name: 'CampaignDashboardHeader'

  resources:
    campaigns:
      resourceName: 'campaigns'
      slug: 'brand_reps/:brandRep.id/campaigns'
      params:
        quick_list: true
        limit: 1000
      fetch: false

  vue:
    props: ['brandRep', 'options']

    data: ->
      showFilter: false
      target: null

    computed:
      dashboard: ->
        @options?.dashboard

      campaign: ->
        @options?.campaign

      optionsForCampaigns: ->
        options = []

        if @campaign
          options.push {
            id: @campaign.id
            name: "#{@campaign.name} (current)"
          }

        for campaign in @campaigns || [] when campaign.id isnt @campaign?.id
          options.push({
            id: campaign.id
            name: campaign.name
          })

        options

      optionsForEventType: ->
        data = @marketplace.listing?.types
        order = @marketplace.listing?.promoted?.types
        listingTypeOptions = @hashToElementUIOptions data, order

      optionsForSuppliers: ->
        @options?.suppliers || []

      optionsForTimeframes: ->
        timeframe: [
          {
            key: 'this_month'
            label: 'This month'
            dates: [
              dayjs().startOf('month').format('YYYY-MM-DD')
              dayjs().endOf('month').format('YYYY-MM-DD')
            ]
          }
          {
            key: 'last_month'
            label: 'Last month'
            dates: [
              dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
              dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
            ]
          }
          {
            key: '3_months'
            label: '3 months'
            dates: [
              dayjs().subtract(3, 'month').startOf('month').format('YYYY-MM-DD')
              dayjs().endOf('month').format('YYYY-MM-DD')
            ]
          }
          {
            key: 'this_year'
            label: 'This year'
            dates: [
              dayjs().startOf('year').format('YYYY-MM-DD')
              dayjs().endOf('year').format('YYYY-MM-DD')
            ]
          }
          {
            key: 'last_year'
            label: 'Last year'
            dates: [
              dayjs().subtract(1, 'year').startOf('year').format('YYYY-MM-DD')
              dayjs().subtract(1, 'year').endOf('year').format('YYYY-MM-DD')
            ]
          }
        ]
        quarter: for n in [1..4]
          {
            key: "Q#{n}"
            label: "Q#{n}"
            dates: [
              dayjs().startOf('year').add((n - 1) * 3, 'month').startOf('month').format('YYYY-MM-DD')
              dayjs().startOf('year').add(n * 3, 'month').subtract(1, 'day').endOf('month').format('YYYY-MM-DD')
            ]
          }
        month: for amount in [2..12]
          {
            key: "subtract_month_#{amount}"
            label: @formatSubtractMonth(amount)
            dates: [
              dayjs().subtract(amount, 'month').startOf('month').format('YYYY-MM-DD')
              dayjs().subtract(amount, 'month').endOf('month').format('YYYY-MM-DD')
            ]
          }

      canApplyFilter: ->
        @isValidTimeWindow

      isValidTimeWindow: ->
        [starts_at, ends_at] = @target.time_window
        dayjs(starts_at).isSameOrBefore(ends_at)

    mounted: ->
      @target = @initialTarget()
      @applyFilter()

      # fetch resources after fetching the dashboard not to block the initial render
      @fetch 'campaigns'

    methods:
      hiDownload: ->
        @$emit 'download'

      hiToggleFilter: ->
        @showFilter = !@showFilter

      hiSetTimeWindow: (dates) ->
        @target.time_window = [...dates]
        @$refs.timeframeDropdown.hide()

      hiSelectCampaigns: ->
        @target.scope.all_brand_rep_campaigns = false

      hiCheckboxCampaigns: ->
        @target.scope.campaign_ids = []

      hiApplyFilter: ->
        @applyFilter()

      hiResetFilter: ->
        @target = @initialTarget()
        @applyFilter()

      applyFilter: ->
        @$emit 'applyFilter', { target: { ...@target } }

      initialTarget: ->
        initialTimeWindow = [...@optionsForTimeframes.timeframe.find(({ key }) => key is '3_months').dates]

        date_field: 'offer_submitted_at'
        time_window: initialTimeWindow
        types: []
        scope:
          all_brand_rep_campaigns: false
          campaign_ids: if @campaign then [@campaign.id] else []
          purchase_order_ids: []
          supplier_ids: []

      formatSubtractMonth: (amount) ->
        now = dayjs()
        date = dayjs().subtract(amount, 'month')
        if now.year() is date.year()
          date.format('MMMM')
        else
          date.format('MMMM YYYY')

export default VueOptions.vue settings
